module.exports = __webpack_public_path__ + "media/images/gift/gift-main-image-pc-b307a7f9244a438df1fd6315626b1cfb.png";